import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-input-errors',
  templateUrl: './input-errors.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslatePipe,
  ],
})
export class InputErrorsComponent {
  @Input() public errorsForField: any;
  @Input() public translationKey: string; // e.g. 'campaigns.form.errors'
  @Input() public additionalErrorsMapping: any; // e.g { 'after': 'some.key' }
  @Input() public areTranslationKeys = true;
  private DEFAULT_TRANSLATION_KEY = 'errors.messages';

  public errorTranslationKey(error: string): string {
    // eslint-disable-next-line no-prototype-builtins
    if (this.additionalErrorsMapping?.hasOwnProperty(error)) {
      return this.additionalErrorsMapping[error];
    }
    if (this.translationKey != null) { return `${this.translationKey}.${error}`; }

    return `${this.DEFAULT_TRANSLATION_KEY}.${error}`;
  }
}
